import React from 'react';
import { DataTable, StatusBadge, mapAuditStatusToTone } from '../../ui-system';

const fmt = (value) => {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString('id-ID');
};

const actionSeverity = (actionType) => {
  const value = String(actionType || '').toLowerCase();
  if (value.includes('delete') || value.includes('failed') || value.includes('reject') || value.includes('error')) return 'critical';
  if (value.includes('update') || value.includes('pending') || value.includes('retry')) return 'warning';
  return 'normal';
};

const AuditLogTable = ({ rows, onSelect }) => {
  const columns = [
    { key: 'createdAt', label: 'Timestamp' },
    { key: 'entityType', label: 'Entity' },
    { key: 'entityId', label: 'Entity ID' },
    { key: 'actionType', label: 'Action' },
    { key: 'actorType', label: 'Actor' },
    { key: 'summary', label: 'Summary' },
  ];

  return (
    <DataTable
      title="Audit Logs"
      subtitle="Jejak aktivitas lintas domain operasional."
      columns={columns}
      rows={rows}
      rowKey="auditId"
      onRowClick={(row) => onSelect?.(row)}
      renderCell={(row, column) => {
        const severity = actionSeverity(row.actionType);
        if (column.key === 'createdAt') return <span className="font-mono text-xs">{fmt(row.createdAt)}</span>;
        if (column.key === 'entityType') return row.entityType || '-';
        if (column.key === 'entityId') return <span className="font-mono">{row.entityId || '-'}</span>;
        if (column.key === 'actionType') return <StatusBadge tone={mapAuditStatusToTone(severity)}>{row.actionType || '-'}</StatusBadge>;
        if (column.key === 'actorType') return <span className="font-mono">{row.actorType}:{row.actorId}</span>;
        if (column.key === 'summary') return row.metadata?.source || row.metadata?.message || '-';
        return row[column.key] || '-';
      }}
    />
  );
};

export default AuditLogTable;
